module.exports = __webpack_public_path__ + "media/images/top/place/other-place2-1d958884e6d34beac884369a014217a2.png";